import yup from 'src/libraries/validator.library';
import {
  IFlightOperatorForm,
  FlightOperatorResponsePayloadSchema,
  FlightOperatorListSchema,
} from 'src/models/flight-operator.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async (activeFlag?: boolean) => {
    return http.get(
      'operators',
      activeFlag ?
      { limit: 0, activeFlag } :
      { limit: 0 },
      FlightOperatorListSchema
    );
  },
  updatePUT: async (id: number, data: IFlightOperatorForm) => {
    return http.put(
      `operators/${id}`,
      data,
      FlightOperatorResponsePayloadSchema
    );
  },
  addPOST: async (data: IFlightOperatorForm) => {
    return http.post('operators', data, FlightOperatorResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`operators/${id}`, yup.mixed());
  },
};

export default services;
